module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"title":"Überweisungsdetails","sepa_e2e_reference":"SEPA Referenz"},"en":{"title":"Bank transfer details","sepa_e2e_reference":"SEPA Reference"}}')
  delete Component.options._Ctor
}
